import styles from "./Register.module.css";

export const permission = [
  {
    type: "PATIENT",
    information: (
      <>
        <p className="indent-12">
          “ผูกพันธุ์” คือระบบดิจิดัลแพลตฟอร์มที่มีจุดประสงค์เพื่อรวบรวมข้อมูลผลการตรวจทางห้องปฏิบัติการที่กรมวิทยาศาสตร์การแพทย์และห้องปฏิบัติการอื่น
          ๆ ให้บริการ และส่งผลกลับไปสู่ประชาชน
          โดยประชาชนสามารถเข้าถึงข้อมูลผลการตรวจของตนเองผ่านทางเว็บไซต์
          หรือแอปพลิเคชัน ผูกพันธุ์
        </p>
        <p className="indent-12">
          นอกจากนี้ แพทย์สามารถใช้ผลการตรวจทางห้องปฏิบัติการกรมวิทยาศาสตร์การแพทย์
          นำร่อง 4 การทดสอบ ได้แก่
        </p>
        <p className="indent-12"> 
          - การตรวจ HLA-B*58:01 เพื่อหลีกเลี่ยงอาการผื่น แพ้ยาที่เกิดจากการได้รับยา Allopurinol
        </p>
        <p className="indent-12"> 
          - การตรวจ HLA-B*15:02 เพื่อหลีกเลี่ยงอาการผื่นแพ้ยาที่เกิดจากการได้รับยา Carbamazepine
        </p>
        <p className="indent-12"> 
          - การตรวจ HLA-B*57:01 เพื่อหลีกเลี่ยงภาวะภูมิคุ้มกันไวเกินจากการใช้ยา Abacavir (Abacavir hypersensitivity reaction)
        </p>
        <p className="indent-12"> 
          - การตรวจ NAT2-Diplotype ตรวจยีนย่อยสลายยา Isoniazid เพื่อพิจารณาให้ยาในขนาดที่เหมาะสม
        </p>
        <p className="indent-12"> 
          - การตรวจ HLA-A*31:01 เพื่อหลีกเลี่ยงอาการผื่นแพ้ยา ที่เกิดจากการได้รับยา Carbamazepine
        </p>
        <p className="indent-12"> 
          - การตรวจ HLA-B*13:01 เพื่อหลีกเลี่ยงอาการผื่นแพ้ยา ที่เกิดจากการได้รับยา Dapsone
        </p>
        <p className="indent-12">
          โรงพยาบาล/ห้องปฏิบัติการอื่นๆ
          สามารถบันทึกผลการตรวจทางห้องปฏิบัติการเข้าสู่ระบบ
          เพื่อให้ผู้ป่วยเข้าถึงข้อมูลผ่าน ”ผูกพันธุ์” ได้ เนื่องจากการตรวจ
          บางรายการ สามารถตรวจครั้งเดียวและใช้ผลการตรวจได้ตลอดชีวิต
          ดังนั้นจึงทำให้ผู้ป่วยและรัฐประหยัดเงินและเวลาในการตรวจซ้ำเมื่อผู้ป่วยเข้ารับการรักษา
          ต่างโรงพยาบาล
          และแพทย์สามารถพิจารณาใช้ผลการตรวจวางแผนป้องกันและรักษาโรคต่อไป
          ซึ่งบริการดังกล่าวจะมีการควบคุมและรักษาความปลอดภัยด้วย
          มาตรการที่เหมาะสมตามที่กรมวิทยาศาสตร์การแพทย์ได้กำหนดไว้แล้ว
          หรือที่จะกำหนดขึ้นในอนาคต ซึ่งในข้อตกลงการให้บริการนี้ ให้
        </p>
        <p className="indent-12">
          “ผู้ให้บริการ” หมายความถึง กรมวิทยาศาสตร์การแพทย์ 
        </p>
        <p className="indent-12">
          “ผู้ใช้บริการ” หมายความถึง ผู้สมัครใช้บริการระบบ
        </p>
        <p style={{
          fontSize: '22px',
          background: 'linear-gradient(to right, #bcd9c6 0%, #aed9d4 50%, #98d8d8 100%)',
          padding: '8px 18px', 
          borderRadius: '12px', 
          fontWeight: 'bold',
        }}>
          ผู้ให้บริการและผู้ใช้บริการได้ตกลงกันโดยมีข้อความดังต่อไปนี้
        </p>
        <p className="indent-12">
          1. ผู้ใช้บริการจะต้องสมัครใช้บริการหรือลงทะเบียนผ่านช่องทางต่าง ๆ ที่ผู้ให้บริการกำหนด โดยการสมัครใช้บริการจะไม่เสียค่าใช้จ่าย ทั้งนี้ ผู้ใช้บริการสามารถ ใช้บริการได้ภายหลังจากได้มีการรับลงทะเบียนเรียบร้อยแล้ว
        </p>
        <p className="indent-12">
          2. ผู้ใช้บริการจะต้องให้ข้อมูลส่วนตัวหรือรายละเอียดที่เกี่ยวข้องกับผู้ใช้บริการตามความเป็นจริง เพื่อประโยชน์แก่การใช้บริการ หากผู้ให้บริการตรวจพบว่าข้อมูล ส่วนตัวหรือรายละเอียดที่เกี่ยวข้องกับผู้ใช้บริการไม่ชัดเจน ไม่ถูกต้อง หรือเป็นข้อมูลเท็จ ไม่ว่าผู้ใช้บริการจะให้ข้อมูลนั้นด้วยความสมัครใจหรือความประมาท เลินเล่อก็ตาม ผู้ให้บริการมีสิทธิที่จะยกเลิกบัญชีของผู้ใช้บริการโดยมิพักต้องบอกกล่าวล่วงหน้า
        </p>
        <p className="indent-12">
          3. ในการใช้บริการบางกรณี ผู้ใช้บริการจะต้องทำการยืนยันตัวบุคคลโดยใช้ e-Mail หรือหมายเลขบัตรประจำตัวประชาชน 13 หลัก ตามที่ผู้ให้บริการกำหนด
        </p>
        <p className="indent-12">
          4. ห้ามมิให้แอบอ้างหรือกระทำการใด ๆ อันเป็นการละเมิดสิทธิส่วนบุคคล โดยการใช้ข้อมูลของผู้อื่นในการสมัครใช้บริการหรือลงทะเบียนผ่านช่องทางต่าง ๆ ซึ่งผู้ที่กระทำการฝ่าฝืนดังกล่าว ต้องรับโทษตามที่กฎหมายกำหนด
        </p>
        <p className="indent-12">
          5. ผู้ใช้บริการจะต้องยินยอมให้ผู้ให้บริการใช้ข้อมูลจากการสมัครใช้บริการหรือลงทะเบียนผ่านช่องทางต่าง ๆ เพื่อให้ผู้ใช้บริการสามารถเข้าถึงบริการได้
        </p>
        <p className="indent-12">
          6. ผู้ให้บริการจะเก็บรักษาข้อมูลของผู้ใช้บริการไว้เป็นความลับ โดยจะไม่นำข้อมูลดังกล่าวไปเปิดเผย นำไปใช้ประโยชน์ทางการค้า หรือกระทำการอื่นใด นอกจาก การดำเนินการทางกฎหมายหรือผู้ใช้บริการให้ความยินยอม
        </p>
        <p className="indent-12">
          7. ผู้ใช้บริการจะต้องรักษาชื่อบัญชีผู้ใช้งานและรหัสผ่านไว้เป็นความลับ หากปรากฏว่ามีผู้อื่นสามารถใช้งานผ่านบัญชีของผู้ใช้บริการได้ ผู้ให้บริการจะไม่รับผิดชอบ ต่อความเสียหายที่เกิดขึ้น
        </p>
        <p className="indent-12">
          8. ผู้ใช้บริการจะต้องปฏิบัติตามเงื่อนไขภายใต้ข้อตกลงการให้บริการโดยเคร่งครัด รวมถึงการปฏิบัติตามนโยบาย ประกาศ คำสั่ง ระเบียบ และข้อบังคับของ ผู้ให้บริการ ตลอดจนกฎหมายที่เกี่ยวข้องกับการใช้บริการทั้งที่ใช้อยู่ในปัจจุบันและที่จะเกิดขึ้นในอนาคต อาทิ พระราชบัญญัติว่าด้วยการกระทำความผิดทาง คอมพิวเตอร์ พ.ศ. 2560, พระราชบัญญัติว่าด้วยธุรกรรมอิเล็กทรอนิกส์ พ.ศ. 2562 เป็นต้น และหรือกฎหมายอื่นที่เกี่ยวข้อง ตลอดจนถือเป็นการกระทำ ความผิดทางวินัยด้วยแล้วแต่กรณี
        </p>
        <p className="indent-12">
          9. การแก้ไข เปลี่ยนแปลง หรือปรับปรุงเงื่อนไขภายใต้ข้อตกลงการให้บริการนี้ ผู้ให้บริการจะแจ้งให้ผู้ใช้บริการทราบ ผ่านทางช่องทางต่าง ๆ ตามความเหมาะสม กับสถานการณ์
          ผู้ใช้บริการได้อ่านและยินยอมให้ผูกพันตามเงื่อนไขภายใต้ข้อตกลงการให้บริการนี้
        </p>
      </>
    ),
    consentForm: (
      <>
        <p className="indent-12">
          ระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์” (ระบบฯ) คือ แพลตฟอร์มดิจิทัลที่มีจุดประสงค์เพื่อรวบรวม
          ข้อมูลพันธุกรรม ที่กรมวิทยาศาสตร์การแพทย์และห้องปฏิบัติการอื่น ๆ ให้บริการ 
          และให้ผู้ใช้งานสามารถ เข้าถึงผลการตรวจ ผ่านช่องทางต่าง ๆ เช่น 
          เว็บไซต์และแอปพลิเคชัน “ผูกพันธุ์” ระเบียนสุขภาพ อิเล็กทรอนิกส์ส่วนบุคคล 
          (Personal Health Record: PHR) และระบบสารสนเทศของโรงพยาบาล 
          (Hospital Information System: HIS) เป็นต้น โดยมีผู้ใช้งานระบบและบทบาทที่เกี่ยวข้อง ดังนี้
        </p>
        <p className="indent-12"> 
          1. ประชาชน เข้าถึงและแสดงผลการตรวจของตนเองให้บุคลาการทางการแพทย์ที่รักษา
        </p>
        <p className="indent-12"> 
          2. บุคลาการทางการแพทย์ เข้าถึงและใช้ผลการตรวจของประชาชน ประกอบการพิจารณาวินิจฉัย ป้องกันและรักษาโรคที่เฉพาะบุคคล ส่งเสริมการรักษา แบบการแพทย์แม่นยำ (Precision Medicine)
        </p>
        <p className="indent-12"> 
          3. ผู้ปฏิบัติงานในห้องปฏิบัติการ ได้แก่ นักเทคนิคการแพทย์ และ นักวิทยาศาสตร์การแพทย์ ลงข้อมูลผลการตรวจในระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”        
        </p>
        <p className="indent-12">
          ระบบฯ รองรับการเชื่อมต่อ PHR ต่าง ๆ ทำให้ประชาชนมีทางเลือกในการเข้าถึงข้อมูลพันธุกรรมมากขึ้น และการเชื่อมโยงข้อมูลกับระบบ HIS ทำให้สามารถรับ-ส่งข้อมูลพันธุกรรมเข้าสู่ระบบของโรงพยาบาลได้
        </p>
        <p className="indent-12">
          ข้าพเจ้ายินยอมให้โรงพยาบาล บุคลากรทางการแพทย์ หน่วยงานภายนอก และภาคส่วนที่เกี่ยวข้องกับระบบสุขภาพที่เข้าร่วมใช้งานระบบฯ
          เก็บรวบรวม เข้าถึง ใช้งาน จัดการ และเปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้า
          โดยมีวัตถุประสงค์ดังต่อไปนี้
        </p>

        <p className="indent-12">
          1. ให้บุคลาการทางการแพทย์ในโรงพยาบาลที่เข้าร่วมใช้งานระบบฯ ผ่านระบบ
          HIS และบุคลาการทางการแพทย์ ที่เข้าร่วมใช้งานระบบฯ
          ที่ได้รับการยินยอมให้เข้าถึงข้อมูลพันธุกรรมของข้าพเจ้า
          สามารถเรียกดูข้อมูลพันธุกรรมอิเล็กทรอนิกส์ เพื่อ
        </p>
        <p className="indent-24">
          1.1 ใช้ข้อมูลประกอบการพิจารณาวินิจฉัย ป้องกันและรักษาโรค
        </p>
        <p className="indent-24">
          1.2 เพิ่มความสะดวกในการเข้ารับการรักษาต่างโรงพยาบาลและส่งต่อข้อมูลทางพันธุกรรมของประชาชน
        </p>
        <p className="indent-24">
          1.3 ลดการตรวจซ้ำซ้อน เนื่องจากผลการตรวจทางพันธุกรรมส่วนมากตรวจเพียงครั้งเดียวสามารถใช้ผลได้ตลอดชีวิต ไม่จำเป็นต้องตรวจซ้ำ
        </p>
        <p className="indent-24">
          1.4 เข้าถึงข้อมูลพันธุกรรมได้ในกรณีฉุกเฉินหรือประชาชนที่กำลังหมดสติเป็นการเพิ่มโอกาสการรักษา แบบทันท่วงที
        </p>
        <p className="indent-12">
          2. พัฒนาประสิทธิภาพการให้บริการทางการแพทย์ของโรงพยาบาลที่เข้าร่วมใช้งานระบบฯ
        </p>
        <p className="indent-12">
          3. พัฒนาประสิทธิภาพและส่งเสริมการให้บริการของระบบฯ
        </p>
        <p className="indent-12">
          4. การปฏิบัติตามเงื่อนไขการให้บริการของระบบฯ
        </p>
        <p className="indent-12">
          5. พัฒนาความปลอดภัยของเครือข่ายและข้อมูล
        </p>

        <p className="indent-12">
          โดยข้อมูลส่วนบุคคลของข้าพเจ้าจะไม่ถูกจัดเก็บเกินกว่าระยะเวลาที่จำเป็นต่อการดำเนินการตามวัตถุประสงค์ข้างต้น เว้นแต่กรณีที่กฎหมายกำหนดเท่านั้น
        </p>
        <p className="indent-12">
          ข้าพเจ้ายินยอมให้โรงพยาบาล บุคลากรทางการแพทย์ หน่วยงานภายนอก และภาคส่วนที่เกี่ยวข้องกับระบบสุขภาพที่เข้าร่วมใช้งานระบบฯ ผ่านระบบ HIS รับ-ส่ง
          เก็บรวบรวม เข้าถึง ใช้งาน จัดการ และเปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้า
          เมื่อข้าพเจ้ากดยอมรับความยินยอมฉบับนี้ จะถือว่าข้าพเจ้ายินยอมให้ทุกโรงพยาบาลที่เข้าร่วมใช้งานระบบฯ ผ่านระบบ
          HIS ณ ปัจจุบัน รวมถึงที่จะเข้าร่วมในอนาคต สามารถรับ-ส่ง เก็บรวบรวม เข้าถึง ใช้งาน จัดการ และเปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้ากับระบบฯ ดังนี้
        </p>
        <p className="indent-12">1. ข้อมูลส่วนตัว เช่น</p>
        <p className="indent-24">1.1 คำนำหน้า</p>
        <p className="indent-24">1.2 ชื่อ-นามสกุล</p>
        <p className="indent-24">1.3 เลขบัตรประจำตัวประชาชน</p>
        <p className="indent-24">1.4 เพศ</p>
        <p className="indent-24">1.5 อายุ</p>
        <p className="indent-24">1.6 หมายเลขโทรศัพท์</p>
        <p className="indent-12">2. ข้อมูลสุขภาพละเอียดอ่อน เช่น</p>
        <p className="indent-24">2.1 ข้อมูลพันธุกรรม</p>
        <p className="indent-12">         
          ข้าพเจ้ายินยอมให้บุคลากรทางการแพทย์ หน่วยงานภายนอก และภาคส่วนที่เกี่ยวข้องกับระบบสุขภาพที่เข้าร่วมใช้งานระบบฯ
          สามารถเข้าถึง ใช้งาน และเปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้า ดังนี้
        </p>
        <p className="indent-12">1. ข้อมูลส่วนตัว เช่น</p>
        <p className="indent-24">1.1 คำนำหน้า</p>
        <p className="indent-24">1.2 ชื่อ-นามสกุล</p>
        <p className="indent-24">1.3 เลขบัตรประจำตัวประชาชน</p>
        <p className="indent-24">1.4 เพศ</p>
        <p className="indent-24">1.5 อายุ</p>
        <p className="indent-24">1.6 หมายเลขโทรศัพท์</p>
        <p className="indent-24">1.7 อีเมลล์</p>
        <p className="indent-12">
          2. ข้อมูลสุขภาพละเอียดอ่อน เช่น
        </p>
        <p className="indent-24">2.1 ข้อมูลพันธุกรรม</p>
        <p className="indent-12">
          หากโรงพยาบาลนำข้อมูลส่วนบุคคลของข้าพเจ้าไปใช้เพื่อวัตถุประสงค์อื่นนอกเหนือจากที่ระบุไว้ข้างต้น
          จะต้องได้รับความยินยอมจากข้าพเจ้าก่อน
          เว้นแต่เป็นการเปิดเผยตามที่กฎหมายบัญญัติหรือมีคำสั่งศาลให้เปิดเผย
        </p>
        <p className="indent-12">
          โดยข้าพเจ้ารับทราบว่าข้าพเจ้าสามารถเปลี่ยนแปลงหรือยกเลิกความยินยอมได้ แต่ไม่มีผลลบล้าง
          ความยินยอม และผลแห่งความยินยอมซึ่งได้กระทำไปแล้ว ก่อนหน้านั้น
        </p>
        <p className="indent-12">
          ข้าพเจ้ายินยอมให้กรมวิทยาศาสตร์การแพทย์ ผู้พัฒนาและดูแลระบบในฐานหน่วยงานที่ได้รับ
          มอบหมายจากกรมวิทยาศาสตร์การแพทย์หน่วยงานภายนอก และภาคส่วนที่เกี่ยวข้องกับระบบสุขภาพ เก็บ
          รวบรวม เข้าถึง ใช้งาน จัดการ และเปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้า โดยยอมรับและตกลงที่จะปฏิบัติตาม
          ข้อกำหนดและเงื่อนไขการใช้บริการตามรายละเอียดใน “ข้อกำหนดและ เงื่อนไขการใช้บริการ ผูกพันธุ์”
        </p>
        <p className="indent-12">
          ได้อ่านและเข้าใจรายละเอียดการให้ความยินยอมข้างต้น รวมไปถึงประกาศนโยบายความเป็นส่วนตัว
          ของประชาชน ตามรายละเอียดใน “นโยบายความเป็นส่วนตัวของประชาชน (Privacy Notice)”
        </p>
        <div>
          <br />
        </div>
        <p>
          หมายเหตุ: ความยินยอมฉบับนี้มีการทบทวนล่าสุดเมื่อวันที่ 24 กุมภาพันธ์ 2569
        </p>
      </>
    ),
  },
  {
    type: "MEDICAL_PERSONNEL",
    information: (
      <div>
        “ผูกพันธุ์”
        คือระบบดิจิดัลแพลตฟอร์มที่มีจุดประสงค์เพื่อรวบรวมข้อมูลผลการตรวจทางห้องปฏิบัติการที่กรมวิทยาศาสตร์การแพทย์และห้องปฏิบัติการอื่น
        ๆ ให้บริการ และส่งผลกลับไปสู่ประชาชน
        โดยประชาชนสามารถเข้าถึงข้อมูลผลการตรวจของตนเองผ่านทางเว็บไซต์
        หรือแอปพลิเคชัน ผูกพันธุ์
        <div className={styles.return}></div>
        นอกจากนี้ แพทย์สามารถใช้ผลการตรวจทางห้องปฏิบัติการกรมวิทยาศาสตร์การแพทย์
        นำร่อง 4 การทดสอบ ได้แก่
        <div></div>
        การตรวจ HLA-B*58:01 เพื่อหลีกเลี่ยงอาการผื่น แพ้ยาที่เกิดจากการได้รับยา
        Allopurinol
        <div></div>
        การตรวจ HLA-B*15:02 เพื่อหลีกเลี่ยงอาการผื่นแพ้ยาที่เกิดจากการได้รับยา
        Carbamazepine
        <div></div>
        การตรวจ HLA-B*57:01 เพื่อหลีกเลี่ยงภาวะภูมิคุ้มกันไวเกินจากการใช้ยา
        Abacavir (Abacavir hypersensitivity reaction)
        <div></div>
        การตรวจ NAT2-Diplotype ตรวจยีนย่อยสลายยา Isoniazid
        เพื่อพิจารณาให้ยาในขนาดที่เหมาะสม
        <div className={styles.return}></div>
        โรงพยาบาล /ห้องปฏิบัติการอื่นๆ
        สามารถบันทึกผลการตรวจทางห้องปฏิบัติการเข้าสู่ระบบ
        เพื่อให้ผู้ป่วยเข้าถึงข้อมูลผ่าน ”ผูกพันธุ์” ได้ เนื่องจากการตรวจ
        บางรายการ สามารถตรวจครั้งเดียวและใช้ผลการตรวจได้ตลอดชีวิต
        ดังนั้นจึงทำให้ผู้ป่วยและรัฐประหยัดเงินและเวลาในการตรวจซ้ำเมื่อผู้ป่วยเข้ารับการรักษา
        ต่างโรงพยาบาล
        และแพทย์สามารถพิจารณาใช้ผลการตรวจวางแผนป้องกันและรักษาโรคต่อไป
        ซึ่งบริการดังกล่าวจะมีการควบคุมและรักษาความปลอดภัยด้วย
        มาตรการที่เหมาะสมตามที่กรมวิทยาศาสตร์การแพทย์ได้กำหนดไว้แล้ว
        หรือที่จะกำหนดขึ้นในอนาคต ซึ่งในข้อตกลงการให้บริการนี้ ให้
        <div className={styles.return}></div>
        “ผู้ให้บริการ” หมายความถึง กรมวิทยาศาสตร์การแพทย์
        <div></div>
        “ผู้ใช้บริการ” หมายความถึง ผู้สมัครใช้บริการระบบ
        <div className={styles.return}></div>
        ผู้ให้บริการ และ ผู้ใช้บริการได้ตกลงกันโดยมีข้อความดังต่อไปนี้
        <div className={styles.return}></div>
        1. ผู้ใช้บริการจะต้องสมัครใช้บริการหรือลงทะเบียนผ่านช่องทางต่าง ๆ
        ที่ผู้ให้บริการกำหนด โดยการสมัครใช้บริการจะไม่เสียค่าใช้จ่าย ทั้งนี้
        ผู้ใช้บริการสามารถ
        ใช้บริการได้ภายหลังจากได้มีการรับลงทะเบียนเรียบร้อยแล้ว
        <div></div>
        2.
        ผู้ใช้บริการจะต้องให้ข้อมูลส่วนตัวหรือรายละเอียดที่เกี่ยวข้องกับผู้ใช้บริการตามความเป็นจริง
        เพื่อประโยชน์แก่การใช้บริการ หากผู้ให้บริการตรวจพบว่าข้อมูล
        ส่วนตัวหรือรายละเอียดที่เกี่ยวข้องกับผู้ใช้บริการไม่ชัดเจน ไม่ถูกต้อง
        หรือเป็นข้อมูลเท็จ
        ไม่ว่าผู้ใช้บริการจะให้ข้อมูลนั้นด้วยความสมัครใจหรือความประมาท
        เลินเล่อก็ตาม
        ผู้ให้บริการมีสิทธิที่จะยกเลิกบัญชีของผู้ใช้บริการโดยมิพักต้องบอกกล่าวล่วงหน้า
        <div></div>
        3. ในการใช้บริการบางกรณี ผู้ใช้บริการจะต้องทำการยืนยันตัวบุคคลโดยใช้
        e-Mail หรือหมายเลขบัตรประจำตัวประชาชน 13 หลัก ตามที่ผู้ให้บริการกำหนด
        <div></div>
        4. ห้ามมิให้แอบอ้างหรือกระทำการใด ๆ อันเป็นการละเมิดสิทธิส่วนบุคคล
        โดยการใช้ข้อมูลของผู้อื่นในการสมัครใช้บริการหรือลงทะเบียนผ่านช่องทางต่าง
        ๆ ซึ่งผู้ที่กระทำการฝ่าฝืนดังกล่าว ต้องรับโทษตามที่กฎหมายกำหนด
        <div></div>
        5.
        ผู้ใช้บริการจะต้องยินยอมให้ผู้ให้บริการใช้ข้อมูลจากการสมัครใช้บริการหรือลงทะเบียนผ่านช่องทางต่าง
        ๆ เพื่อให้ผู้ใช้บริการสามารถเข้าถึงบริการได้
        <div></div>
        6. ผู้ให้บริการจะเก็บรักษาข้อมูลของผู้ใช้บริการไว้เป็นความลับ
        โดยจะไม่นำข้อมูลดังกล่าวไปเปิดเผย นำไปใช้ประโยชน์ทางการค้า
        หรือกระทำการอื่นใด นอกจาก
        การดำเนินการทางกฎหมายหรือผู้ใช้บริการให้ความยินยอม
        <div></div>
        7. ผู้ใช้บริการจะต้องรักษาชื่อบัญชีผู้ใช้งานและรหัสผ่านไว้เป็นความลับ
        หากปรากฏว่ามีผู้อื่นสามารถใช้งานผ่านบัญชีของผู้ใช้บริการได้
        ผู้ให้บริการจะไม่รับผิดชอบ ต่อความเสียหายที่เกิดขึ้น
        <div></div>
        8.
        ผู้ใช้บริการจะต้องปฏิบัติตามเงื่อนไขภายใต้ข้อตกลงการให้บริการโดยเคร่งครัด
        รวมถึงการปฏิบัติตามนโยบาย ประกาศ คำสั่ง ระเบียบ และข้อบังคับของ
        ผู้ให้บริการ
        ตลอดจนกฎหมายที่เกี่ยวข้องกับการใช้บริการทั้งที่ใช้อยู่ในปัจจุบันและที่จะเกิดขึ้นในอนาคต
        อาทิ พระราชบัญญัติว่าด้วยการกระทำความผิดทาง คอมพิวเตอร์ พ.ศ. 2560 ,
        พระราชบัญญัติว่าด้วยธุรกรรมอิเล็กทรอนิกส์ พ.ศ. 2562 เป็นต้น
        และหรือกฎหมายอื่นที่เกี่ยวข้อง ตลอดจนถือเป็นการกระทำ
        ความผิดทางวินัยด้วยแล้วแต่กรณี
        <div></div>
        9. การแก้ไข เปลี่ยนแปลง หรือปรับปรุงเงื่อนไขภายใต้ข้อตกลงการให้บริการนี้
        ผู้ให้บริการจะแจ้งให้ผู้ใช้บริการทราบ ผ่านทางช่องทางต่าง ๆ
        ตามความเหมาะสม กับสถานการณ์
        <div className={styles.return}></div>
        ผู้ใช้บริการได้อ่านและยินยอมให้ผูกพันตามเงื่อนไขภายใต้ข้อตกลงการให้บริการนี้
      </div>
    ),
    consentForm: (
      <div>
        ข้าพเจ้าให้สัญญา ตกลงจะรักษาความลับข้อมูลด้านสุขภาพของผู้รับบริการ อาทิ
        รายการ และ/ หรือรายละเอียด และ/ หรือภาพ และ/ หรือข้อมูลใด ๆ
        ที่เกี่ยวข้องกับข้อมูลด้านสุขภาพของบุคคล ตาม พรบ. สุขภาพแห่งชาติ พ.ศ.
        2550 มาตรา 7<div className={styles.return}></div>
        “ข้อมูลด้านสุขภาพของบุคคล เป็นความลับส่วนบุคคล นำไป
        เปิดเผยในประการที่จะทำให้บุคคลนั้นเสียหายไม่ได้
        เว้นแต่การเปิดเผยนั้นเป็นไปตามความ ประสงค์ของบุคคลนั้นโดยตรง
        หรือมีกฎหมายเฉพาะบัญญัติให้ต้อง เปิดเผย แต่ไม่ว่าในกรณีใด ๆ
        ผู้ใดจะอาศัยอำนาจหรือสิทธิ ตามกฎหมายว่าด้วยข้อมูล ข่าวสารของราชการ
        หรือกฎหมายอื่นเพื่อขอเอกสารเกี่ยวกับข้อมูลด้าน
        สุขภาพของบุคคลที่ไม่ใช่ของตนไม่ได้” และประมวลกฎหมายอาญา มาตรา 323
        บัญญัติ ไว้ว่า
        <div className={styles.return}></div>
        “ผู้ใดล่วงรู้หรือได้มาซึ่งความลับของผู้อื่นโดยเหตุที่เป็นเจ้าพนักงานผู้มีหน้าที่
        โดยเหตุที่ประกอบอาชีพแพทย์ เภสัชกร คนจำหน่ายยา นางผดุงครรภ์ ผู้พยาบาล
        นักบวช หมอความ
        ทนายความหรือผู้สอบบัญชีหรือโดยเหตุที่เป็นผู้ช่วยในการประกอบอาชีพนั้น
        แล้วเปิดเผยความลับนั้นในประการที่น่าจะเกิดความ เสียหายแก่ผู้หนึ่งผู้ใด
        ต้องระวางโทษจำคุกไม่เกินหกเดือน หรือปรับไม่เกินหนึ่งพันบาท
        หรือทั้งจำทั้งปรับ”
        <div className={styles.return}></div>
        ข้าพเจ้าตกลงรักษาข้อมูลที่เป็นความลับและไม่เปิดเผยข้อมูลของผู้ป่วย
      </div>
    ),
  },
  {
    type: "HOSPITAL_PERSONNEL",
    information: (
      <div>
        “ผูกพันธุ์”
        คือระบบดิจิดัลแพลตฟอร์มที่มีจุดประสงค์เพื่อรวบรวมข้อมูลผลการตรวจทางห้องปฏิบัติการที่กรมวิทยาศาสตร์การแพทย์และห้องปฏิบัติการอื่น
        ๆ ให้บริการ และส่งผลกลับไปสู่ประชาชน
        โดยประชาชนสามารถเข้าถึงข้อมูลผลการตรวจของตนเองผ่านทางเว็บไซต์
        หรือแอปพลิเคชัน ผูกพันธุ์
        <div className={styles.return}></div>
        นอกจากนี้ แพทย์สามารถใช้ผลการตรวจทางห้องปฏิบัติการกรมวิทยาศาสตร์การแพทย์
        นำร่อง 4 การทดสอบ ได้แก่
        <div></div>
        การตรวจ HLA-B*58:01 เพื่อหลีกเลี่ยงอาการผื่น แพ้ยาที่เกิดจากการได้รับยา
        Allopurinol
        <div></div>
        การตรวจ HLA-B*15:02 เพื่อหลีกเลี่ยงอาการผื่นแพ้ยาที่เกิดจากการได้รับยา
        Carbamazepine
        <div></div>
        การตรวจ HLA-B*57:01 เพื่อหลีกเลี่ยงภาวะภูมิคุ้มกันไวเกินจากการใช้ยา
        Abacavir (Abacavir hypersensitivity reaction)
        <div></div>
        การตรวจ NAT2-Diplotype ตรวจยีนย่อยสลายยา Isoniazid
        เพื่อพิจารณาให้ยาในขนาดที่เหมาะสม
        <div className={styles.return}></div>
        โรงพยาบาล /ห้องปฏิบัติการอื่นๆ
        สามารถบันทึกผลการตรวจทางห้องปฏิบัติการเข้าสู่ระบบ
        เพื่อให้ผู้ป่วยเข้าถึงข้อมูลผ่าน ”ผูกพันธุ์” ได้ เนื่องจากการตรวจ
        บางรายการ สามารถตรวจครั้งเดียวและใช้ผลการตรวจได้ตลอดชีวิต
        ดังนั้นจึงทำให้ผู้ป่วยและรัฐประหยัดเงินและเวลาในการตรวจซ้ำเมื่อผู้ป่วยเข้ารับการรักษา
        ต่างโรงพยาบาล
        และแพทย์สามารถพิจารณาใช้ผลการตรวจวางแผนป้องกันและรักษาโรคต่อไป
        ซึ่งบริการดังกล่าวจะมีการควบคุมและรักษาความปลอดภัยด้วย
        มาตรการที่เหมาะสมตามที่กรมวิทยาศาสตร์การแพทย์ได้กำหนดไว้แล้ว
        หรือที่จะกำหนดขึ้นในอนาคต ซึ่งในข้อตกลงการให้บริการนี้ ให้
        <div className={styles.return}></div>
        “ผู้ให้บริการ” หมายความถึง กรมวิทยาศาสตร์การแพทย์
        <div></div>
        “ผู้ใช้บริการ” หมายความถึง ผู้สมัครใช้บริการระบบ
        <div className={styles.return}></div>
        ผู้ให้บริการ และ ผู้ใช้บริการได้ตกลงกันโดยมีข้อความดังต่อไปนี้
        <div className={styles.return}></div>
        1. ผู้ใช้บริการจะต้องสมัครใช้บริการหรือลงทะเบียนผ่านช่องทางต่าง ๆ
        ที่ผู้ให้บริการกำหนด โดยการสมัครใช้บริการจะไม่เสียค่าใช้จ่าย ทั้งนี้
        ผู้ใช้บริการสามารถ
        ใช้บริการได้ภายหลังจากได้มีการรับลงทะเบียนเรียบร้อยแล้ว
        <div></div>
        2.
        ผู้ใช้บริการจะต้องให้ข้อมูลส่วนตัวหรือรายละเอียดที่เกี่ยวข้องกับผู้ใช้บริการตามความเป็นจริง
        เพื่อประโยชน์แก่การใช้บริการ หากผู้ให้บริการตรวจพบว่าข้อมูล
        ส่วนตัวหรือรายละเอียดที่เกี่ยวข้องกับผู้ใช้บริการไม่ชัดเจน ไม่ถูกต้อง
        หรือเป็นข้อมูลเท็จ
        ไม่ว่าผู้ใช้บริการจะให้ข้อมูลนั้นด้วยความสมัครใจหรือความประมาท
        เลินเล่อก็ตาม
        ผู้ให้บริการมีสิทธิที่จะยกเลิกบัญชีของผู้ใช้บริการโดยมิพักต้องบอกกล่าวล่วงหน้า
        <div></div>
        3. ในการใช้บริการบางกรณี ผู้ใช้บริการจะต้องทำการยืนยันตัวบุคคลโดยใช้
        e-Mail หรือหมายเลขบัตรประจำตัวประชาชน 13 หลัก ตามที่ผู้ให้บริการกำหนด
        <div></div>
        4. ห้ามมิให้แอบอ้างหรือกระทำการใด ๆ อันเป็นการละเมิดสิทธิส่วนบุคคล
        โดยการใช้ข้อมูลของผู้อื่นในการสมัครใช้บริการหรือลงทะเบียนผ่านช่องทางต่าง
        ๆ ซึ่งผู้ที่กระทำการฝ่าฝืนดังกล่าว ต้องรับโทษตามที่กฎหมายกำหนด
        <div></div>
        5.
        ผู้ใช้บริการจะต้องยินยอมให้ผู้ให้บริการใช้ข้อมูลจากการสมัครใช้บริการหรือลงทะเบียนผ่านช่องทางต่าง
        ๆ เพื่อให้ผู้ใช้บริการสามารถเข้าถึงบริการได้
        <div></div>
        6. ผู้ให้บริการจะเก็บรักษาข้อมูลของผู้ใช้บริการไว้เป็นความลับ
        โดยจะไม่นำข้อมูลดังกล่าวไปเปิดเผย นำไปใช้ประโยชน์ทางการค้า
        หรือกระทำการอื่นใด นอกจาก
        การดำเนินการทางกฎหมายหรือผู้ใช้บริการให้ความยินยอม
        <div></div>
        7. ผู้ใช้บริการจะต้องรักษาชื่อบัญชีผู้ใช้งานและรหัสผ่านไว้เป็นความลับ
        หากปรากฏว่ามีผู้อื่นสามารถใช้งานผ่านบัญชีของผู้ใช้บริการได้
        ผู้ให้บริการจะไม่รับผิดชอบ ต่อความเสียหายที่เกิดขึ้น
        <div></div>
        8.
        ผู้ใช้บริการจะต้องปฏิบัติตามเงื่อนไขภายใต้ข้อตกลงการให้บริการโดยเคร่งครัด
        รวมถึงการปฏิบัติตามนโยบาย ประกาศ คำสั่ง ระเบียบ และข้อบังคับของ
        ผู้ให้บริการ
        ตลอดจนกฎหมายที่เกี่ยวข้องกับการใช้บริการทั้งที่ใช้อยู่ในปัจจุบันและที่จะเกิดขึ้นในอนาคต
        อาทิ พระราชบัญญัติว่าด้วยการกระทำความผิดทาง คอมพิวเตอร์ พ.ศ. 2560 ,
        พระราชบัญญัติว่าด้วยธุรกรรมอิเล็กทรอนิกส์ พ.ศ. 2562 เป็นต้น
        และหรือกฎหมายอื่นที่เกี่ยวข้อง ตลอดจนถือเป็นการกระทำ
        ความผิดทางวินัยด้วยแล้วแต่กรณี
        <div></div>
        9. การแก้ไข เปลี่ยนแปลง หรือปรับปรุงเงื่อนไขภายใต้ข้อตกลงการให้บริการนี้
        ผู้ให้บริการจะแจ้งให้ผู้ใช้บริการทราบ ผ่านทางช่องทางต่าง ๆ
        ตามความเหมาะสม กับสถานการณ์
        <div className={styles.return}></div>
        ผู้ใช้บริการได้อ่านและยินยอมให้ผูกพันตามเงื่อนไขภายใต้ข้อตกลงการให้บริการนี้
      </div>
    ),
    consentForm: (
      <div>
        ข้าพเจ้าให้สัญญา ตกลงจะรักษาความลับข้อมูลด้านสุขภาพของผู้รับบริการ อาทิ
        รายการ และ/ หรือรายละเอียด และ/ หรือภาพ และ/ หรือข้อมูลใด ๆ
        ที่เกี่ยวข้องกับข้อมูลด้านสุขภาพของบุคคล ตาม พรบ. สุขภาพแห่งชาติ พ.ศ.
        2550 มาตรา 7<div className={styles.return}></div>
        “ข้อมูลด้านสุขภาพของบุคคล เป็นความลับส่วนบุคคล นำไป
        เปิดเผยในประการที่จะทำให้บุคคลนั้นเสียหายไม่ได้
        เว้นแต่การเปิดเผยนั้นเป็นไปตามความ ประสงค์ของบุคคลนั้นโดยตรง
        หรือมีกฎหมายเฉพาะบัญญัติให้ต้อง เปิดเผย แต่ไม่ว่าในกรณีใด ๆ
        ผู้ใดจะอาศัยอำนาจหรือสิทธิ ตามกฎหมายว่าด้วยข้อมูล ข่าวสารของราชการ
        หรือกฎหมายอื่นเพื่อขอเอกสารเกี่ยวกับข้อมูลด้าน
        สุขภาพของบุคคลที่ไม่ใช่ของตนไม่ได้” และประมวลกฎหมายอาญา มาตรา 323
        บัญญัติ ไว้ว่า
        <div className={styles.return}></div>
        “ผู้ใดล่วงรู้หรือได้มาซึ่งความลับของผู้อื่นโดยเหตุที่เป็นเจ้าพนักงานผู้มีหน้าที่
        โดยเหตุที่ประกอบอาชีพแพทย์ เภสัชกร คนจำหน่ายยา นางผดุงครรภ์ ผู้พยาบาล
        นักบวช หมอความ
        ทนายความหรือผู้สอบบัญชีหรือโดยเหตุที่เป็นผู้ช่วยในการประกอบอาชีพนั้น
        แล้วเปิดเผยความลับนั้นในประการที่น่าจะเกิดความ เสียหายแก่ผู้หนึ่งผู้ใด
        ต้องระวางโทษจำคุกไม่เกินหกเดือน หรือปรับไม่เกินหนึ่งพันบาท
        หรือทั้งจำทั้งปรับ”
        <div className={styles.return}></div>
        ข้าพเจ้าตกลงรักษาข้อมูลที่เป็นความลับและไม่เปิดเผยข้อมูลของผู้ป่วย
      </div>
    ),
  },
  {
    type: "LABORATORY_ADMIN",
    information: (
      <div>
        “ผูกพันธุ์”
        คือระบบดิจิดัลแพลตฟอร์มที่มีจุดประสงค์เพื่อรวบรวมข้อมูลผลการตรวจทางห้องปฏิบัติการที่กรมวิทยาศาสตร์การแพทย์และห้องปฏิบัติการอื่น
        ๆ ให้บริการ และส่งผลกลับไปสู่ประชาชน
        โดยประชาชนสามารถเข้าถึงข้อมูลผลการตรวจของตนเองผ่านทางเว็บไซต์
        หรือแอปพลิเคชัน ผูกพันธุ์
        <div className={styles.return}></div>
        นอกจากนี้ แพทย์สามารถใช้ผลการตรวจทางห้องปฏิบัติการกรมวิทยาศาสตร์การแพทย์
        นำร่อง 4 การทดสอบ ได้แก่
        <div></div>
        การตรวจ HLA-B*58:01 เพื่อหลีกเลี่ยงอาการผื่น แพ้ยาที่เกิดจากการได้รับยา
        Allopurinol
        <div></div>
        การตรวจ HLA-B*15:02 เพื่อหลีกเลี่ยงอาการผื่นแพ้ยาที่เกิดจากการได้รับยา
        Carbamazepine
        <div></div>
        การตรวจ HLA-B*57:01 เพื่อหลีกเลี่ยงภาวะภูมิคุ้มกันไวเกินจากการใช้ยา
        Abacavir (Abacavir hypersensitivity reaction)
        <div></div>
        การตรวจ NAT2-Diplotype ตรวจยีนย่อยสลายยา Isoniazid
        เพื่อพิจารณาให้ยาในขนาดที่เหมาะสม
        <div className={styles.return}></div>
        โรงพยาบาล /ห้องปฏิบัติการอื่นๆ
        สามารถบันทึกผลการตรวจทางห้องปฏิบัติการเข้าสู่ระบบ
        เพื่อให้ผู้ป่วยเข้าถึงข้อมูลผ่าน ”ผูกพันธุ์” ได้ เนื่องจากการตรวจ
        บางรายการ สามารถตรวจครั้งเดียวและใช้ผลการตรวจได้ตลอดชีวิต
        ดังนั้นจึงทำให้ผู้ป่วยและรัฐประหยัดเงินและเวลาในการตรวจซ้ำเมื่อผู้ป่วยเข้ารับการรักษา
        ต่างโรงพยาบาล
        และแพทย์สามารถพิจารณาใช้ผลการตรวจวางแผนป้องกันและรักษาโรคต่อไป
        ซึ่งบริการดังกล่าวจะมีการควบคุมและรักษาความปลอดภัยด้วย
        มาตรการที่เหมาะสมตามที่กรมวิทยาศาสตร์การแพทย์ได้กำหนดไว้แล้ว
        หรือที่จะกำหนดขึ้นในอนาคต ซึ่งในข้อตกลงการให้บริการนี้ ให้
        <div className={styles.return}></div>
        “ผู้ให้บริการ” หมายความถึง กรมวิทยาศาสตร์การแพทย์
        <div></div>
        “ผู้ใช้บริการ” หมายความถึง ผู้สมัครใช้บริการระบบ
        <div className={styles.return}></div>
        ผู้ให้บริการ และ ผู้ใช้บริการได้ตกลงกันโดยมีข้อความดังต่อไปนี้
        <div className={styles.return}></div>
        1. ผู้ใช้บริการจะต้องสมัครใช้บริการหรือลงทะเบียนผ่านช่องทางต่าง ๆ
        ที่ผู้ให้บริการกำหนด โดยการสมัครใช้บริการจะไม่เสียค่าใช้จ่าย ทั้งนี้
        ผู้ใช้บริการสามารถ
        ใช้บริการได้ภายหลังจากได้มีการรับลงทะเบียนเรียบร้อยแล้ว
        <div></div>
        2.
        ผู้ใช้บริการจะต้องให้ข้อมูลส่วนตัวหรือรายละเอียดที่เกี่ยวข้องกับผู้ใช้บริการตามความเป็นจริง
        เพื่อประโยชน์แก่การใช้บริการ หากผู้ให้บริการตรวจพบว่าข้อมูล
        ส่วนตัวหรือรายละเอียดที่เกี่ยวข้องกับผู้ใช้บริการไม่ชัดเจน ไม่ถูกต้อง
        หรือเป็นข้อมูลเท็จ
        ไม่ว่าผู้ใช้บริการจะให้ข้อมูลนั้นด้วยความสมัครใจหรือความประมาท
        เลินเล่อก็ตาม
        ผู้ให้บริการมีสิทธิที่จะยกเลิกบัญชีของผู้ใช้บริการโดยมิพักต้องบอกกล่าวล่วงหน้า
        <div></div>
        3. ในการใช้บริการบางกรณี ผู้ใช้บริการจะต้องทำการยืนยันตัวบุคคลโดยใช้
        e-Mail หรือหมายเลขบัตรประจำตัวประชาชน 13 หลัก ตามที่ผู้ให้บริการกำหนด
        <div></div>
        4. ห้ามมิให้แอบอ้างหรือกระทำการใด ๆ อันเป็นการละเมิดสิทธิส่วนบุคคล
        โดยการใช้ข้อมูลของผู้อื่นในการสมัครใช้บริการหรือลงทะเบียนผ่านช่องทางต่าง
        ๆ ซึ่งผู้ที่กระทำการฝ่าฝืนดังกล่าว ต้องรับโทษตามที่กฎหมายกำหนด
        <div></div>
        5.
        ผู้ใช้บริการจะต้องยินยอมให้ผู้ให้บริการใช้ข้อมูลจากการสมัครใช้บริการหรือลงทะเบียนผ่านช่องทางต่าง
        ๆ เพื่อให้ผู้ใช้บริการสามารถเข้าถึงบริการได้
        <div></div>
        6. ผู้ให้บริการจะเก็บรักษาข้อมูลของผู้ใช้บริการไว้เป็นความลับ
        โดยจะไม่นำข้อมูลดังกล่าวไปเปิดเผย นำไปใช้ประโยชน์ทางการค้า
        หรือกระทำการอื่นใด นอกจาก
        การดำเนินการทางกฎหมายหรือผู้ใช้บริการให้ความยินยอม
        <div></div>
        7. ผู้ใช้บริการจะต้องรักษาชื่อบัญชีผู้ใช้งานและรหัสผ่านไว้เป็นความลับ
        หากปรากฏว่ามีผู้อื่นสามารถใช้งานผ่านบัญชีของผู้ใช้บริการได้
        ผู้ให้บริการจะไม่รับผิดชอบ ต่อความเสียหายที่เกิดขึ้น
        <div></div>
        8.
        ผู้ใช้บริการจะต้องปฏิบัติตามเงื่อนไขภายใต้ข้อตกลงการให้บริการโดยเคร่งครัด
        รวมถึงการปฏิบัติตามนโยบาย ประกาศ คำสั่ง ระเบียบ และข้อบังคับของ
        ผู้ให้บริการ
        ตลอดจนกฎหมายที่เกี่ยวข้องกับการใช้บริการทั้งที่ใช้อยู่ในปัจจุบันและที่จะเกิดขึ้นในอนาคต
        อาทิ พระราชบัญญัติว่าด้วยการกระทำความผิดทาง คอมพิวเตอร์ พ.ศ. 2560 ,
        พระราชบัญญัติว่าด้วยธุรกรรมอิเล็กทรอนิกส์ พ.ศ. 2562 เป็นต้น
        และหรือกฎหมายอื่นที่เกี่ยวข้อง ตลอดจนถือเป็นการกระทำ
        ความผิดทางวินัยด้วยแล้วแต่กรณี
        <div></div>
        9. การแก้ไข เปลี่ยนแปลง หรือปรับปรุงเงื่อนไขภายใต้ข้อตกลงการให้บริการนี้
        ผู้ให้บริการจะแจ้งให้ผู้ใช้บริการทราบ ผ่านทางช่องทางต่าง ๆ
        ตามความเหมาะสม กับสถานการณ์
        <div className={styles.return}></div>
        ผู้ใช้บริการได้อ่านและยินยอมให้ผูกพันตามเงื่อนไขภายใต้ข้อตกลงการให้บริการนี้
      </div>
    ),
    consentForm: (
      <div>
        ข้าพเจ้าให้สัญญา ตกลงจะรักษาความลับข้อมูลด้านสุขภาพของผู้รับบริการ อาทิ
        รายการ และ/หรือรายละเอียด และ/หรือภาพและ/หรือข้อมูลใด ๆ ที่เกี่ยวข้อง
        กับข้อมูลด้านสุขภาพของบุคคล ตาม พรบ. สุขภาพแห่งชาติ พ.ศ. 2550 มาตรา 7
        <div className={styles.return}></div>
        “ข้อมูลด้านสุขภาพของบุคคล เป็นความลับส่วนบุคคล
        นำไปเปิดเผยในประการที่จะทำให้บุคคลนั้นเสียหายไม่ได้
        เว้นแต่การเปิดเผยนั้นเป็นไปตามความประสงค์ ของบุคคลนั้นโดยตรง
        หรือมีกฎหมายเฉพาะบัญญัติให้ต้องเปิดเผย แต่ไม่ว่าในกรณีใด ๆ
        ผู้ใดจะอาศัยอำนาจหรือสิทธิ ตามกฎหมายว่าด้วยข้อมูลข่าวสารของ ราชการ
        หรือกฎหมายอื่นเพื่อขอเอกสารเกี่ยวกับข้อมูลด้านสุขภาพของบุคคลที่ไม่ใช่ของตนไม่ได้”
        และประมวลกฎหมายอาญา มาตรา 323 บัญญัติไว้ว่า
        <div className={styles.return}></div>
        “ผู้ใดล่วงรู้หรือได้มาซึ่งความลับของผู้อื่นโดยเหตุที่เป็นเจ้าพนักงานผู้มีหน้าที่
        โดยเหตุที่ประกอบอาชีพแพทย์ เภสัชกร คนจำหน่ายยา นางผดุงครรภ์ ผู้พยาบาล
        นักบวช หมอความ
        ทนายความหรือผู้สอบบัญชีหรือโดยเหตุที่เป็นผู้ช่วยในการประกอบอาชีพนั้น
        แล้วเปิดเผยความลับนั้นในประการที่น่าจะเกิดความ เสียหายแก่ผู้หนึ่งผู้ใด
        ต้องระวางโทษจำคุกไม่เกินหกเดือน หรือปรับไม่เกินหนึ่งพันบาท
        หรือทั้งจำทั้งปรับ”
        <div className={styles.return}></div>
        ข้าพเจ้าตกลงรักษาข้อมูลที่เป็นความลับและไม่เปิดเผยข้อมูลของผู้ป่วย
      </div>
    ),
  },
  {
    type: "LABORATORY_PERSONNEL",
    information: (
      <div>
        “ผูกพันธุ์”
        คือระบบดิจิดัลแพลตฟอร์มที่มีจุดประสงค์เพื่อรวบรวมข้อมูลผลการตรวจทางห้องปฏิบัติการที่กรมวิทยาศาสตร์การแพทย์และห้องปฏิบัติการอื่น
        ๆ ให้บริการ และส่งผลกลับไปสู่ประชาชน
        โดยประชาชนสามารถเข้าถึงข้อมูลผลการตรวจของตนเองผ่านทางเว็บไซต์
        หรือแอปพลิเคชัน ผูกพันธุ์
        <div className={styles.return}></div>
        นอกจากนี้ แพทย์สามารถใช้ผลการตรวจทางห้องปฏิบัติการกรมวิทยาศาสตร์การแพทย์
        นำร่อง 4 การทดสอบ ได้แก่
        <div></div>
        การตรวจ HLA-B*58:01 เพื่อหลีกเลี่ยงอาการผื่น แพ้ยาที่เกิดจากการได้รับยา
        Allopurinol
        <div></div>
        การตรวจ HLA-B*15:02 เพื่อหลีกเลี่ยงอาการผื่นแพ้ยาที่เกิดจากการได้รับยา
        Carbamazepine
        <div></div>
        การตรวจ HLA-B*57:01 เพื่อหลีกเลี่ยงภาวะภูมิคุ้มกันไวเกินจากการใช้ยา
        Abacavir (Abacavir hypersensitivity reaction)
        <div></div>
        การตรวจ NAT2-Diplotype ตรวจยีนย่อยสลายยา Isoniazid
        เพื่อพิจารณาให้ยาในขนาดที่เหมาะสม
        <div className={styles.return}></div>
        โรงพยาบาล /ห้องปฏิบัติการอื่นๆ
        สามารถบันทึกผลการตรวจทางห้องปฏิบัติการเข้าสู่ระบบ
        เพื่อให้ผู้ป่วยเข้าถึงข้อมูลผ่าน ”ผูกพันธุ์” ได้ เนื่องจากการตรวจ
        บางรายการ สามารถตรวจครั้งเดียวและใช้ผลการตรวจได้ตลอดชีวิต
        ดังนั้นจึงทำให้ผู้ป่วยและรัฐประหยัดเงินและเวลาในการตรวจซ้ำเมื่อผู้ป่วยเข้ารับการรักษา
        ต่างโรงพยาบาล
        และแพทย์สามารถพิจารณาใช้ผลการตรวจวางแผนป้องกันและรักษาโรคต่อไป
        ซึ่งบริการดังกล่าวจะมีการควบคุมและรักษาความปลอดภัยด้วย
        มาตรการที่เหมาะสมตามที่กรมวิทยาศาสตร์การแพทย์ได้กำหนดไว้แล้ว
        หรือที่จะกำหนดขึ้นในอนาคต ซึ่งในข้อตกลงการให้บริการนี้ ให้
        <div className={styles.return}></div>
        “ผู้ให้บริการ” หมายความถึง กรมวิทยาศาสตร์การแพทย์
        <div></div>
        “ผู้ใช้บริการ” หมายความถึง ผู้สมัครใช้บริการระบบ
        <div className={styles.return}></div>
        ผู้ให้บริการ และ ผู้ใช้บริการได้ตกลงกันโดยมีข้อความดังต่อไปนี้
        <div className={styles.return}></div>
        1. ผู้ใช้บริการจะต้องสมัครใช้บริการหรือลงทะเบียนผ่านช่องทางต่าง ๆ
        ที่ผู้ให้บริการกำหนด โดยการสมัครใช้บริการจะไม่เสียค่าใช้จ่าย ทั้งนี้
        ผู้ใช้บริการสามารถ
        ใช้บริการได้ภายหลังจากได้มีการรับลงทะเบียนเรียบร้อยแล้ว
        <div></div>
        2.
        ผู้ใช้บริการจะต้องให้ข้อมูลส่วนตัวหรือรายละเอียดที่เกี่ยวข้องกับผู้ใช้บริการตามความเป็นจริง
        เพื่อประโยชน์แก่การใช้บริการ หากผู้ให้บริการตรวจพบว่าข้อมูล
        ส่วนตัวหรือรายละเอียดที่เกี่ยวข้องกับผู้ใช้บริการไม่ชัดเจน ไม่ถูกต้อง
        หรือเป็นข้อมูลเท็จ
        ไม่ว่าผู้ใช้บริการจะให้ข้อมูลนั้นด้วยความสมัครใจหรือความประมาท
        เลินเล่อก็ตาม
        ผู้ให้บริการมีสิทธิที่จะยกเลิกบัญชีของผู้ใช้บริการโดยมิพักต้องบอกกล่าวล่วงหน้า
        <div></div>
        3. ในการใช้บริการบางกรณี ผู้ใช้บริการจะต้องทำการยืนยันตัวบุคคลโดยใช้
        e-Mail หรือหมายเลขบัตรประจำตัวประชาชน 13 หลัก ตามที่ผู้ให้บริการกำหนด
        <div></div>
        4. ห้ามมิให้แอบอ้างหรือกระทำการใด ๆ อันเป็นการละเมิดสิทธิส่วนบุคคล
        โดยการใช้ข้อมูลของผู้อื่นในการสมัครใช้บริการหรือลงทะเบียนผ่านช่องทางต่าง
        ๆ ซึ่งผู้ที่กระทำการฝ่าฝืนดังกล่าว ต้องรับโทษตามที่กฎหมายกำหนด
        <div></div>
        5.
        ผู้ใช้บริการจะต้องยินยอมให้ผู้ให้บริการใช้ข้อมูลจากการสมัครใช้บริการหรือลงทะเบียนผ่านช่องทางต่าง
        ๆ เพื่อให้ผู้ใช้บริการสามารถเข้าถึงบริการได้
        <div></div>
        6. ผู้ให้บริการจะเก็บรักษาข้อมูลของผู้ใช้บริการไว้เป็นความลับ
        โดยจะไม่นำข้อมูลดังกล่าวไปเปิดเผย นำไปใช้ประโยชน์ทางการค้า
        หรือกระทำการอื่นใด นอกจาก
        การดำเนินการทางกฎหมายหรือผู้ใช้บริการให้ความยินยอม
        <div></div>
        7. ผู้ใช้บริการจะต้องรักษาชื่อบัญชีผู้ใช้งานและรหัสผ่านไว้เป็นความลับ
        หากปรากฏว่ามีผู้อื่นสามารถใช้งานผ่านบัญชีของผู้ใช้บริการได้
        ผู้ให้บริการจะไม่รับผิดชอบ ต่อความเสียหายที่เกิดขึ้น
        <div></div>
        8.
        ผู้ใช้บริการจะต้องปฏิบัติตามเงื่อนไขภายใต้ข้อตกลงการให้บริการโดยเคร่งครัด
        รวมถึงการปฏิบัติตามนโยบาย ประกาศ คำสั่ง ระเบียบ และข้อบังคับของ
        ผู้ให้บริการ
        ตลอดจนกฎหมายที่เกี่ยวข้องกับการใช้บริการทั้งที่ใช้อยู่ในปัจจุบันและที่จะเกิดขึ้นในอนาคต
        อาทิ พระราชบัญญัติว่าด้วยการกระทำความผิดทาง คอมพิวเตอร์ พ.ศ. 2560 ,
        พระราชบัญญัติว่าด้วยธุรกรรมอิเล็กทรอนิกส์ พ.ศ. 2562 เป็นต้น
        และหรือกฎหมายอื่นที่เกี่ยวข้อง ตลอดจนถือเป็นการกระทำ
        ความผิดทางวินัยด้วยแล้วแต่กรณี
        <div></div>
        9. การแก้ไข เปลี่ยนแปลง หรือปรับปรุงเงื่อนไขภายใต้ข้อตกลงการให้บริการนี้
        ผู้ให้บริการจะแจ้งให้ผู้ใช้บริการทราบ ผ่านทางช่องทางต่าง ๆ
        ตามความเหมาะสม กับสถานการณ์
        <div className={styles.return}></div>
        ผู้ใช้บริการได้อ่านและยินยอมให้ผูกพันตามเงื่อนไขภายใต้ข้อตกลงการให้บริการนี้
      </div>
    ),
    consentForm: (
      <div>
        ข้าพเจ้าให้สัญญา ตกลงจะรักษาความลับข้อมูลด้านสุขภาพของผู้รับบริการ อาทิ
        รายการ และ/หรือรายละเอียด และ/หรือภาพและ/หรือข้อมูลใด ๆ ที่เกี่ยวข้อง
        กับข้อมูลด้านสุขภาพของบุคคล ตาม พรบ. สุขภาพแห่งชาติ พ.ศ. 2550 มาตรา 7
        <div className={styles.return}></div>
        “ข้อมูลด้านสุขภาพของบุคคล เป็นความลับส่วนบุคคล
        นำไปเปิดเผยในประการที่จะทำให้บุคคลนั้นเสียหายไม่ได้
        เว้นแต่การเปิดเผยนั้นเป็นไปตามความประสงค์ ของบุคคลนั้นโดยตรง
        หรือมีกฎหมายเฉพาะบัญญัติให้ต้องเปิดเผย แต่ไม่ว่าในกรณีใด ๆ
        ผู้ใดจะอาศัยอำนาจหรือสิทธิ ตามกฎหมายว่าด้วยข้อมูลข่าวสารของ ราชการ
        หรือกฎหมายอื่นเพื่อขอเอกสารเกี่ยวกับข้อมูลด้านสุขภาพของบุคคลที่ไม่ใช่ของตนไม่ได้”
        และประมวลกฎหมายอาญา มาตรา 323 บัญญัติไว้ว่า
        <div className={styles.return}></div>
        “ผู้ใดล่วงรู้หรือได้มาซึ่งความลับของผู้อื่นโดยเหตุที่เป็นเจ้าพนักงานผู้มีหน้าที่
        โดยเหตุที่ประกอบอาชีพแพทย์ เภสัชกร คนจำหน่ายยา นางผดุงครรภ์ ผู้พยาบาล
        นักบวช หมอความ
        ทนายความหรือผู้สอบบัญชีหรือโดยเหตุที่เป็นผู้ช่วยในการประกอบอาชีพนั้น
        แล้วเปิดเผยความลับนั้นในประการที่น่าจะเกิดความ เสียหายแก่ผู้หนึ่งผู้ใด
        ต้องระวางโทษจำคุกไม่เกินหกเดือน หรือปรับไม่เกินหนึ่งพันบาท
        หรือทั้งจำทั้งปรับ”
        <div className={styles.return}></div>
        ข้าพเจ้าตกลงรักษาข้อมูลที่เป็นความลับและไม่เปิดเผยข้อมูลของผู้ป่วย
      </div>
    ),
  },
];

export const pathRole = (data) => {
  switch (data) {
    case "PATIENT":
      return "ลงทะเบียนสำหรับประชาชนทั่วไป";
    case "MEDICAL_PERSONNEL":
      return "ลงทะเบียนสำหรับแพทย์หรือเภสัชกร";
    case "LABORATORY_ADMIN":
      return "ลงทะเบียนสำหรับผู้ดูแลห้องปฏิบัติการ";
    case "LABORATORY_PERSONNEL":
      return "ลงทะเบียนสำหรับผู้ปฏิบัติงานในห้องปฏิบัติการ";
    case "HOSPITAL_PERSONNEL":
      return "ลงทะเบียนสำหรับเจ้าหน้าที่โรงพยาบาล";
    default:
      return "";
  }
};
